/**
 * @author Adam Vlasek <adam.vlasek@styrax.cz>
 */

import React, { DetailedHTMLProps, SelectHTMLAttributes, forwardRef } from 'react';

import FormElementWrapper from '../common/FormElementWrapper';
import { Field } from '../FormHoc';

import { IFormElement } from '../types';

export type SelectProps = DetailedHTMLProps<SelectHTMLAttributes<HTMLSelectElement>, HTMLSelectElement> & IFormElement;

/**
 * Rozsireni select, pridava label, helper (informacni text) a error (chybovou hlasku)
 * @param name Name selectu.
 * @param label Label selectu.
 * @param helper Helper - informacni text k selectu.
 * @param required Boolean priznak zobrazujici cervenou hvezdicku u labelu.
 * @param error Chybova hlaska k selectu.
 * @example <Select name={} label={} helper={} onSubmit={} error={} />
 * @returns React komponenta
 */
export const Select = forwardRef<HTMLSelectElement, SelectProps>(({ label, error, helper, noRenderStar, ...props }, ref) => (
    <FormElementWrapper {...{ label, error, helper, noRenderStar, ...props }}>
        <select
            ref={ref}
            {...{
                ...props,
                id: props.id || props.name,
                className: 'form-select ' + (props.className || '')
            }} />
    </FormElementWrapper>
));

/**
 * Rozsireni select, pridava label, helper (informacni text) a error (chybovou hlasku)
 * Automaticky se napoji na FormHoc, neni potreba manualne predavat value a onChange.
 * @param name Name selectu.
 * @param label Label selectu.
 * @param helper Helper - informacni text k selectu.
 * @param required Boolean priznak zobrazujici cervenou hvezdicku u labelu.
 * @param error Chybova hlaska k selectu.
 * @example <Select name={} label={} helper={} onSubmit={} error={} />
 * @returns React komponenta
 */
const SelectWrapper = forwardRef<HTMLSelectElement, any>((props, ref) => (
    <Field {...props}>
        <Select ref={ref} {...props} />
    </Field>
));

export default SelectWrapper;
